import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
	selector: '[addAttribute]',
	standalone: true,
})
export class PageNotFoundDirective implements OnInit {
	@Input() addAttribute: any;

	constructor(private element: ElementRef, private renderer: Renderer2) {}

	ngOnInit() {
		this.renderer.setAttribute(
			this.element.nativeElement,
			this.addAttribute,
			''
		);
	}
}
